export default [
  /**
   * 选择医院
   * query
   * **** isHos ‘1’为医院导航 无 为楼层导航
   */
  {
    path: '/navigation/chooseHos',
    component: () => import('../pages/navigation/hos')
  },
  /**
   * 医院导航
   * query
   * **** hosId
   */
  {
    path: '/navigation/index',
    component: () => import('../pages/navigation/hospital-navigation')
  },

  /** 楼层导航 **/
  {
  path: '/hospital-floor',
  component: () => import('../pages/navigation/hospital-floor')
},
  {
  path: '/floor-guide',
  name: 'floor-guide',
  meta: {
    title: '楼层导航'
  },
  component: () => import('../pages/navigation/floor-guide')
},
  {
    path: '/floor-data',
    name: 'floor-data',
    meta: {
      title: '楼层导航'
    },
    component: () => import('../pages/navigation/floor-data')
  },

  /** 地图导航 **/
  {
  path: '/map-navigation',
  name: 'map-navigation',
  component: () => import('../pages/navigation/map-navigation')
},

  /** 地图导航 **/
  {
  path: '/peripheral-services',
  name: 'peripheral-services',
  component: () => import('../pages/navigation/peripheral-services')
},
  /** 绝对定位楼层导航 **/
  {
    path: '/absolute-map',
    name: 'absolute-map',
    component: () => import('../pages/navigation/absolute-guide/absolute-map')
  },
]



// WEBPACK FOOTER //
// ./src/router/navigation.js